export const environment = {
  production: false,
  HostName: process.env.REACT_APP_COLLECTOR_BASEURL,
  Settings_Host: process.env.REACT_APP_SETTINGS_BASEURL,
  Socket_Host: process.env.REACT_APP_SOCKET_BASEURL,
  Fusion_Host: process.env.REACT_APP_FUSION_BASEURL,
  Omni_Host: process.env.REACT_APP_OMNI_BASEURL,
  AiAssistant_Host: process.env.REACT_APP_AIASSISTANT_BASEURL,
}

export const COLLECTOR_URL = environment.HostName
export const SETTINGS_URL = environment.Settings_Host
export const SOCKET_URL = environment.Socket_Host
export const FUSION_URL = environment.Fusion_Host
export const OMNI_URL = environment.Omni_Host
export const AIASSISTANT_URL = environment.AiAssistant_Host

export function getAuthObject() {
  const authUser = localStorage.getItem('authUser')
  let authObj = {}
  if (typeof authUser === 'string') {
    try {
      authObj = JSON.parse(authUser)
    } catch (e) {
      // default to remove any bad local storage
      localStorage.removeItem('authUser')
    }
  }
  return authObj
}

export const getToken = () => {
  return getAuthObject()?.authToken
}

export const getRefreshToken = () => {
  return getAuthObject()?.authRefreshToken
}

export const getUserFromLocal = () => {
  return getAuthObject()?.user
}

const onRequest = (config) => {
  const token = getToken()

  if (token) {
    config.headers['authorization'] = token
  }

  return config
}

const onBearerRequest = (config) => {
  const token = getToken()

  if (token) {
    config.headers['authorization'] = 'Bearer ' + token
  }

  return config
}

const onRequestError = (error) => {
  return Promise.reject(error)
}

const onResponse = (response) => {
  return response
}

const logoutErrors = ['No redis session found.', 'Invalid or expired JWT', 'Authorize failed']
const onResponseError = (error) => {
  if (error.response) {
    if (error.response.status === 401 && logoutErrors.includes(error.response.data.message)) {
      localStorage.removeItem('authUser')
      if (window) {
        window.location.replace('/')
      }

      return Promise.reject('Error: Authorization-expired')
    }
  }
  return Promise.reject(error)
}

export const setupInterceptorsTo = (axiosInstance, type = '') => {
  if (type === 'FUSION' || type === 'OMNI' || type === 'AI_ASSISTANT') {
    axiosInstance.interceptors.request.use(onBearerRequest, onRequestError)
  } else {
    axiosInstance.interceptors.request.use(onRequest, onRequestError)
  }
  axiosInstance.interceptors.response.use(onResponse, onResponseError)
  return axiosInstance
}
